var _rect, _g, _rect2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgInfoActive = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 31,
    height: 31,
    rx: 15.5,
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6128_39823)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.0002 19.9997L20.0002 19.9997M17.3335 14.6663H20.0002M17.3335 11.9997H20.0002M12.0002 17.333L20.0002 17.333M14.6668 22.6663H17.3335C19.2003 22.6663 20.1338 22.6663 20.8468 22.303C21.474 21.9835 21.9839 21.4735 22.3035 20.8463C22.6668 20.1333 22.6668 19.1998 22.6668 17.333V14.6663C22.6668 12.7995 22.6668 11.8661 22.3035 11.153C21.9839 10.5258 21.474 10.0159 20.8468 9.69632C20.1338 9.33301 19.2003 9.33301 17.3335 9.33301L14.6668 9.33301C12.8 9.33301 11.8666 9.33301 11.1535 9.69632C10.5263 10.0159 10.0164 10.5258 9.69681 11.153C9.3335 11.8661 9.3335 12.7995 9.3335 14.6663L9.3335 17.333C9.3335 19.1999 9.3335 20.1333 9.69681 20.8463C10.0164 21.4735 10.5263 21.9835 11.1535 22.303C11.8666 22.6663 12.8 22.6663 14.6668 22.6663ZM13.1735 14.6663H13.4935C13.9042 14.6663 14.1096 14.6663 14.2664 14.5864C14.4044 14.5161 14.5166 14.4039 14.5869 14.2659C14.6668 14.1091 14.6668 13.9037 14.6668 13.493V13.173C14.6668 12.7623 14.6668 12.557 14.5869 12.4001C14.5166 12.2621 14.4044 12.1499 14.2664 12.0796C14.1096 11.9997 13.9042 11.9997 13.4935 11.9997H13.1735C12.7628 11.9997 12.5574 11.9997 12.4006 12.0796C12.2626 12.1499 12.1504 12.2621 12.0801 12.4001C12.0002 12.557 12.0002 12.7623 12.0002 13.173V13.493C12.0002 13.9037 12.0002 14.1091 12.0801 14.2659C12.1504 14.4039 12.2626 14.5161 12.4006 14.5864C12.5574 14.6663 12.7628 14.6663 13.1735 14.6663Z",
    stroke: "#4D6EF5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 31,
    height: 31,
    rx: 15.5,
    stroke: "#4D6EF5"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6128_39823"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(8 8)"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgInfoActive);
export default ForwardRef;